import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { ItemReturnMaster } from "./ItemReturnMaster";



const ItemReturnManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    <Route exact path={`${url}`} render={() => <ItemReturnMaster />} />
    
  </Switch>
);

export const ItemReturnManagement = withRouter(ItemReturnManagementRoutes);
